"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaYupConfigEmailSmtp = exports.yupConfigEmailSmtp = void 0;
const yup = __importStar(require("yup"));
exports.yupConfigEmailSmtp = yup.object({
    cbx_email_smtp_auth: yup
        .boolean()
        .notRequired()
        .nullable()
        .default(false)
        .label('Autenticação (Meu servidor de saída SMTP requer autenticação) '),
    cbx_email_smtp_sec: yup
        .boolean()
        .notRequired()
        .nullable()
        .default(false)
        .label('TLS (Este servidor requer uma conexão criptografada)'),
    txt_email_smtp_end: yup.string().notRequired().nullable().default('').label('Servidor de saída (SMTP)'),
    txt_email_smtp_port: yup.string().notRequired().nullable().default('').label('Porta de saída (SMTP)'),
    txt_origem_email: yup.string().email().notRequired().nullable().default('').label('E-mail / Login'),
    txt_origem_nome: yup.string().notRequired().nullable().default('').label('Escola'),
    txt_origem_senha: yup.string().notRequired().nullable().default('').label('Senha'),
});
exports.schemaYupConfigEmailSmtp = exports.yupConfigEmailSmtp.shape({});
